// import FloatingButtonScrollUp from './components/shared/FloatingButtonScrollUp';
import { Sidebar } from './components/shared/Sidebar';
import AppRoute from './routes/Route';
import ReactGA from 'react-ga4';
import { useEffect } from 'react';
import { useLocation } from 'react-router-dom';
import { ModalChat } from './components/shared/ChatBot';

function App() {
  const location = useLocation();

  useEffect(() => {
    ReactGA.initialize('G-X2HSPZXSPX');
    ReactGA.send({ hitType: 'pageview', page: location.pathname });
  }, [location]);

  return (
    <>
        {/* <FloatingButtonScrollUp /> */}
        <ModalChat />
        <AppRoute />
        <Sidebar />
    </>
  );
}

export default App;
